// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header[data-v-2dff99f3] {\r\n  text-align: center;\r\n  padding-top: 16px;\n}\n.client_logo[data-v-2dff99f3] {\r\n  max-width: 170px;\r\n  max-height: 34px;\r\n  height: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
